import './Article.css';

export default function HomePage() {
  return (
    <article className="Article">
      <h1 className="Article__title">Гоночное такси</h1>
      <p className="Article__paragraph">
        Гоночное такси – отличная возможность насладиться скоростью и
        мастерством гонщика, сидя на месте штурмана, и стать свидетелем
        настоящего мастерства профессиональных инструкторов Сочи Автодрома, в
        полной мере ощутив крутые виражи на самой современной гоночной трассе
        России.
      </p>
    </article>
  );
}
